<template>
  <v-dialog v-model="dialog" max-width="380" content-class="confirm-dialog">
    <div class="confirm-card">
      <h3 class="confirm-card__title">{{ title }}</h3>
      <p class="confirm-card__message">{{ message }}</p>

      <div class="confirm-card__actions">
        <button class="confirm-card__btn confirm-card__btn--cancel" @click="disagree">
          {{ options.btnDisagree }}
        </button>
        <button class="confirm-card__btn confirm-card__btn--confirm" @click="agree">
          {{ options.btnAgree || 'Confirm' }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import HrdcData from "@/services/hrdc/objects/globalData";

export default {
  name: "ConfirmPopup",
  data() {
    return {
      hrdcData: new HrdcData(),
      dialog: false,
      title: "",
      message: "",
      options: {
        btnDisagree: "Cancel",
        btnAgree: "Confirm",
      },
      agreeCallback: null,
      disagreeCallback: null,
    };
  },
  methods: {
    open({
      title,
      message,
      options = {
        btnDisagree: "Cancel",
        btnAgree: "Confirm",
      },
      agree = () => {},
      disagree = () => {},
    }) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = options;
      this.agreeCallback = agree;
      this.disagreeCallback = disagree;
    },
    disagree() {
      this.dialog = false;
      this.disagreeCallback();
    },
    agree() {
      this.agreeCallback();
      this.dialog = false;
    },
  },
};
</script>

<style>
/* Both `.dark-mode` blocks that used to bracket this file are gone — there were
   two of them, disagreeing (one painted .confirm-card --app-card, the other
   --app-page), and whichever the bundler emitted last won. Every rule below is
   token-driven and states each element once. NOT scoped, because Vuetify
   detaches v-dialog content out of this component. */

.confirm-dialog {
  border-radius: var(--glass-radius-lg) !important;
  overflow: hidden;
  box-shadow: var(--glass-lift-modal) !important;
}

.confirm-card {
  background: var(--app-navbar);
  border: 1px solid var(--app-border);
  border-radius: var(--glass-radius-lg);
  box-shadow: inset 0 1px 0 var(--app-inner-highlight);
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Opaque baseline above, frost here — see the note in theme-glass.css §3. */
@supports ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .confirm-card {
    background: var(--app-menu-glass);
    -webkit-backdrop-filter: blur(var(--glass-blur-panel)) saturate(var(--glass-saturate));
    backdrop-filter: blur(var(--glass-blur-panel)) saturate(var(--glass-saturate));
  }
}

.confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--app-text);
  margin: 0 0 10px;
}

.confirm-card__message {
  font-size: 0.9rem;
  color: var(--app-text-muted);
  margin: 0 0 28px;
  line-height: 1.5;
}

.confirm-card__hint {
  font-size: 0.78rem;
  color: var(--app-text-faint);
  margin: -16px 0 24px;
  line-height: 1.4;
  font-style: italic;
}

.confirm-card__actions {
  display: flex;
  gap: 12px;
}

.confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: var(--glass-radius-sm);
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.confirm-card__btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--app-ring);
}

.confirm-card__btn--cancel {
  background: var(--app-card);
  color: var(--app-accent-strong);
  border: 1.5px solid var(--app-border-strong);
}

.confirm-card__btn--cancel:hover {
  background: var(--app-elevated);
  border-color: var(--app-accent);
}

/* The two solid buttons take --app-accent-fg / --app-on-solid rather than white:
   on the dark theme's brighter accent and danger fills, white text drops below
   AA. Those tokens are near-black there and white in light. */
.confirm-card__btn--confirm {
  background: var(--app-accent);
  color: var(--app-accent-fg);
  border: none;
}

.confirm-card__btn--confirm:hover {
  background: var(--app-accent);
  box-shadow: 0 4px 12px var(--app-accent-glow);
}

.confirm-card__btn--danger {
  background: var(--app-danger);
  color: var(--app-on-solid);
  border: none;
}

.confirm-card__btn--danger:hover {
  background: var(--app-danger);
  box-shadow: 0 4px 12px var(--app-ring-danger);
}
</style>
